import { useState } from "react";
import { faqItems } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 border-t border-background-200/80">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-widest text-primary-600">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              关于入口与地址的常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              打不开、找不到首页、网址变了……这些问题的答案其实都很固定，下面整理了最常被问到的几条。
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              {faqItems.map((f, i) => {
                const isOpen = openIndex === i;
                return (
                  <div
                    key={f.q}
                    className="border-b border-background-200 last:border-b-0"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : i)}
                      className="flex w-full items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                      aria-expanded={isOpen}
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-950">
                        {f.q}
                      </span>
                      <span className="w-6 h-6 shrink-0 flex items-center justify-center text-foreground-500">
                        <i
                          className={
                            isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"
                          }
                        ></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-4 md:px-5 pb-5 -mt-1">
                        <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}